import { render, staticRenderFns } from "./ArticlePost.vue?vue&type=template&id=879a0434&scoped=true"
import script from "./ArticlePost.vue?vue&type=script&lang=js"
export * from "./ArticlePost.vue?vue&type=script&lang=js"
import style0 from "./ArticlePost.vue?vue&type=style&index=0&id=879a0434&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879a0434",
  null
  
)

export default component.exports